module.exports = __webpack_public_path__ + "img/5.8c68bd73.png";